import { useMutation } from "@apollo/client";
import clsx from "clsx";
import useText from "constants/text";
import {
  BadgeRequest,
  CardRequest,
  CenterCardRequest,
  ContainerElements,
  ContainerIcon,
  ContainerRecapHeader,
  DateRecapCard,
  Evolution,
  FooterCardRequest,
  HeaderCardRequest,
  LinearEvulotionRequest,
  NumberOfVehicleSpan,
  ReccurenceModalOnHover,
  SectionCenterCardRequest,
  StatusRequest,
  VehicleItem,
  VehiclesModalOnHover,
  VehiclesNumbers,
} from "domains/Request/component/shared/MainStyles";
import { renderIconRequest, renderReccurenceOption } from "domains/Request/component/shared/RenderOptions";
import { renderRequestType } from "domains/Request/component/shared/utils";
import { updateRequestEvent } from "domains/Request/graphql/mutation";
import { EPlatform, Request, Vehicles } from "generated/graphql";
import { MADIcon, MADReccurenceIconSimple, NTIcon, RequestCalendarIcon, TourNewIcon } from "icons";
import moment from "moment";
import React, { useEffect, useState } from "react";

export const requestStatusColor = {
  REQUESTED: "57, 158, 191",
  ACCEPTED: "249, 148, 72",
  APPROVED: "50, 212, 21",
  DECLINED: "228, 78, 81",
};

export const requestTypeTextColor = {
  MAD: "#757a93",
  NT: "#394FBF",
  TR: "#2ba815",
  DEFAULT: "#399ebf",
};

export const requestTypeBgColor = {
  Sama_Papser: "#BFD7F8",        
};

export const getRequestEvolution = {
  REQUESTED: "33%",
  ACCEPTED: "66%",
  DECLINED: "100%",
  APPROVED: "100%",
};

const getRequestTypeIcon = {
  MAD: <MADIcon width={56} height={70} color="" />,
  NT: <NTIcon width={56} height={70} color="" />,
  TR: <TourNewIcon width={56} height={70} color="" />,
};
interface IRequestCard {
  requestQuote: Request;
  isSelected?: boolean;
  setNewRequestBadgeTimeOut: React.Dispatch<React.SetStateAction<boolean>>;
}
export default function RequestCard({ requestQuote, isSelected = false, setNewRequestBadgeTimeOut }: IRequestCard) {
  const [alreadyDisplayedBadge, setAlreadyDisplayedBadge] = useState(false);
  const [updateRequestEventClientSide] = useMutation(updateRequestEvent);
  const { text } = useText();

  const formatDate = (value: string) => {
    if (!value) {
      return "N/A";
    }
    const date = moment(value);
    return date.isValid() ? date.format("DD/MM/YYYY") : "";
  };

  const updateRequest = () => {
    try {
      updateRequestEventClientSide({
        variables: {
          input: {
            id: requestQuote?._id,
            platform: EPlatform.Client,
          },
        },
      });
    } catch (error) { }
  };

  useEffect(() => {
    if (isSelected && requestQuote?.view?.byClient) {
      const timer = setTimeout(() => {
        setAlreadyDisplayedBadge(true);
        setNewRequestBadgeTimeOut(true);
        updateRequest();
      }, 4000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [isSelected, requestQuote]);

  const getNumberOfVehicles = (vehicles: Vehicles[]) =>
    vehicles.reduce((prev, next) => prev + next.numberOfVehicule, 0);

  const renderHeaderCard = () => (
    <ContainerRecapHeader background-color="transparent">
      <ContainerIcon background-color={requestTypeBgColor[requestQuote.type]}>
        {getRequestTypeIcon[requestQuote?.type]}
      </ContainerIcon>
      <ContainerElements color={requestTypeTextColor[requestQuote.type]}>
        {renderRequestType(requestQuote?.type, text)}
        <DateRecapCard>
          <div>
            <RequestCalendarIcon />
          </div>
          <div style={{ marginLeft: "5px" }}>{formatDate(requestQuote?.startDate)}</div>
        </DateRecapCard>
      </ContainerElements>
      {requestQuote?.view?.byClient && (
        <BadgeRequest style={{ display: alreadyDisplayedBadge ? "none" : "block" }}>{text.all.new}</BadgeRequest>
      )}
    </ContainerRecapHeader>
  );

  return (
    <CardRequest aria-selected={isSelected}>
      <HeaderCardRequest>{renderHeaderCard()}</HeaderCardRequest>
      <CenterCardRequest>
        <SectionCenterCardRequest>
          <VehiclesNumbers style={{ margin: "0px 10px" }}>
            {`${getNumberOfVehicles(requestQuote.vehicles)} Vehicles`}
            <VehiclesModalOnHover className={clsx({ vehiclesModal: true })}>
              {requestQuote.vehicles.map(({ vehicleType, numberOfVehicule }) => (
                <VehicleItem key={vehicleType}>
                  <NumberOfVehicleSpan> {numberOfVehicule} </NumberOfVehicleSpan>
                  <span>{renderIconRequest(vehicleType, requestTypeTextColor.DEFAULT, 36)}</span>
                  <span>{vehicleType.replace("_", " ")}</span>
                </VehicleItem>
              ))}
            </VehiclesModalOnHover>
          </VehiclesNumbers>
        </SectionCenterCardRequest>
        <SectionCenterCardRequest>
          <div>
            <MADReccurenceIconSimple fill={requestTypeTextColor[requestQuote.type]} />
          </div>
          <div>{renderReccurenceOption(requestQuote, text, true)}</div>
          <ReccurenceModalOnHover className={clsx({ reccurenceModal: true })}>
            <div>{renderReccurenceOption(requestQuote, text)}</div>
          </ReccurenceModalOnHover>
        </SectionCenterCardRequest>
      </CenterCardRequest>
      <FooterCardRequest>
        <LinearEvulotionRequest>
          <Evolution
            style={{ width: getRequestEvolution[requestQuote.status] }}
            background-color={requestStatusColor[requestQuote.status]}
          />
        </LinearEvulotionRequest>
        <StatusRequest background-color={requestStatusColor[requestQuote.status]} style={{ width: "35%" }}>
          {requestQuote.status}
        </StatusRequest>
      </FooterCardRequest>
    </CardRequest>
  );
}
